import React from 'react';
import { Table } from '@mui/material';
var FbmTable = function (_a) {
    var children = _a.children;
    return (React.createElement(Table, null, children));
};
export default FbmTable;
